<template>
  <div class="receipt-container">
    <div v-if="isDataReady">
      <div
        v-for="(items, pageIndex) in hasil"
        :key="pageIndex"
        class="receipt-page"
      >
        <ReceiptHeader type="outlet" :data="outlet" />
        <div class="receipt-content">
          <h4 class="title">
            <b>Laporan Barang Per Bulan (Group)</b>
          </h4>
          <div class="info-section">
            <div class="info-row">
              <div class="info-label">Periode:</div>
              <div class="info-value">{{ start_date }} s/d {{ end_date }}</div>
            </div>
          </div>
          <div class="table-wrapper">
            <table class="detail-bon">
              <thead>
                <tr>
                  <th>No</th>
                  <th>Kode</th>
                  <th>Nama</th>
                  <th>Kategori</th>
                  <th>Qty In</th>
                  <th>Qty Sold</th>
                  <th>Qty Retur</th>
                  <th>Qty Transfer</th>
                  <th>Stok</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(an_item, k) in items" :key="k">
                  <td>{{ k + 1 }}</td>
                  <td>{{ an_item.item_code }}</td>
                  <td>{{ an_item.item_name }}</td>
                  <td>{{ an_item.category_name }}</td>
                  <td>{{ an_item.qty_in }}</td>
                  <td>{{ an_item.qty_sold }}</td>
                  <td>{{ an_item.qty_retur }}</td>
                  <td>{{ an_item.qty_transfer }}</td>
                  <td>{{ an_item.stock }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ReceiptHeader from '@/components/receipt/ReceiptHeader.vue'
import moment from 'moment'

export default {
  name: 'ReceiptGroupItemsPerMonth',
  components: {
    ReceiptHeader
  },
  data() {
    return {
      outlet: null,
      hasil: [],
      isDataReady: false,
      start_date: moment().startOf('month').format('YYYY-MM-DD'),
      end_date: moment().endOf('month').format('YYYY-MM-DD')
    }
  },
  mounted() {
    this.getOutlet()
    this.getReport()
  },
  methods: {
    async getOutlet() {
      try {
        const response = await this.$http.get(
          `${process.env.VUE_APP_API_URL}/outlets/${this.$route.query.outlet_id}`
        )
        if (response.status === 200) {
          this.outlet = response.data.data.outlets
        }
      } catch (error) {
        console.error('Error fetching outlet:', error)
      }
    },
    async getReport() {
      try {
        const params = new URLSearchParams({
          start_date: this.start_date,
          end_date: this.end_date
        })
        const response = await this.$http.get(
          `${
            process.env.VUE_APP_API_URL
          }/report/group-items-per-month?${params.toString()}`
        )
        if (response.status === 200) {
          this.hasil = this.splitLength(response.data.data.items, 20)
          this.isDataReady = true
          setTimeout(() => {
            window.print()
          }, 500)
        }
      } catch (error) {
        console.error('Error fetching report:', error)
      }
    },
    splitLength(array, length) {
      const result = []
      for (let i = 0; i < array.length; i += length) {
        result.push(array.slice(i, i + length))
      }
      return result
    }
  }
}
</script>

<style scoped lang="scss">
@import '@/assets/styles/receipt.scss';
</style>
